import { render } from "./Train.vue?vue&type=template&id=0c730add&ts=true"
import script from "./Train.vue?vue&type=script&lang=ts"
export * from "./Train.vue?vue&type=script&lang=ts"

import "./Train.vue?vue&type=style&index=0&id=0c730add&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__